import { VarsSettings } from "../pages/types";
import 'moment/locale/ko';
import moment from 'moment'
// import { CheckAuth } from '../modules/getAuth';
import { AxiosInstance } from 'axios';

export const checkToken = (api:AxiosInstance) =>{
  try {
    const userInfo = localStorage.getItem('userInfo')
    if(!userInfo) return;
    if(userInfo){
      const parsedUserInfo = JSON.parse(userInfo)
      api.defaults.headers.common['AccessToken']= parsedUserInfo.token
    }
  } catch (error) {
    console.log('localstorage is not working')
  }
}

export const smsAgreeShow = (vars:VarsSettings) => {
  try {
    const isSmsAgreedShow = vars.filter(item=>item.substitution=== '$is_sms_agreed')[0].show;
    return isSmsAgreedShow;
  } catch (error) {
    return false;
  }
}

export const validatePhoneNumber = () =>{
  //추후 추가
  return false;
}

export const formatCardNumber = (s) => {
  return s.toString().replace(/\d{4}(?=.)/g, '$& ');
}

export const ISOStringToDateFormat = (t:string) =>{
  if(t==='1990-01-01 00:00:00'){
    return '----'
  }else{
    const time = new Date(t)
    const date = moment(time)
    return date.locale('kr').format('YYYY. M. D. a h:mm')
  }
};

export const ISOStringToDateFormatStbDate = (t:string) =>{
  if(t==='1990-01-01 00:00:00'){
    return '----'
  }else{
    const time = new Date(t)
    const date = moment(time)
    return date.locale('kr').format('YYYY. M. D.')
  }
};

export const numberWithCommas = (s:string) => {
  return s?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const cardFormat = (s:string) =>{
  return s.toString().replace(/XXXX/g, '****').replace(/-/g, ' ');
}

export const expiryFormat = (s) =>{
  const splitted = s.split(' / ')
  const yy = splitted[1]
  const mm =  splitted[0]
  return '20'+yy+'/'+mm
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
}

export function linkify(inputText:string) {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  replacedText = inputText.replace(/\</g, '&lt')
  replacedText = replacedText.replace(/\>/g, '&gt')
  
  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = replacedText.replace(replacePattern1, '<a href="$1" rel="noopener noreferrer" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" rel="noopener noreferrer" target="_blank">$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  // replacedText = replacedText.replace('<', '&lt')
  // replacedText = replacedText.replace('>', '&gt')
  return replacedText;
}